import { languageIcon, shareIcon } from 'assets/icons';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';

const Iframe = ({ base64PDF, ref, fileLanguage, inputfilename, showShare, showModal, modalOption }: { base64PDF: any, ref: any, fileLanguage: string, inputfilename: string, showShare: any, showModal: boolean, modalOption: string },) => {
    const docuMatePDF = useSelector((state: any) => state.counter.docuMatePDF);
    const docuMateRadio = useSelector((state: any) => state.counter.docuMateRadio);
    const docuMateUserQuery = useSelector((state: any) => state.counter.docuMateUserQuery);
    const [isHeaderVisisble, setIsHeaderVisisble] = useState(false)
    // const modalOption = useSelector((state: any) => state.counter.modalOption);
    const [pdfSrc, setPdfSrc] = useState<string | null>(null);

    function isBase64(str: any) {
        if (typeof str !== 'string') return false;
        if (str.length % 4 !== 0) return false;
    
        const base64Regex = /^[A-Za-z0-9+/]*={0,2}$/;
        return base64Regex.test(str);
    }
    
    function processBase64PDF(base64PDF: string) {
        const cleanedBase64String = base64PDF.startsWith("data:application/pdf;base64,")
            ? base64PDF.replace(/^data:application\/pdf;base64,/, "")
            : base64PDF;
    
        if (isBase64(cleanedBase64String)) {
            const byteCharacters = atob(cleanedBase64String);
            const byteNumbers = Array.from(byteCharacters).map(c => c.charCodeAt(0));
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], { type: 'application/pdf' });
            return URL.createObjectURL(blob); 
        } else {
            return null; 
        }
    }

    useEffect(() => {
        const src = processBase64PDF(base64PDF);
        setPdfSrc(src);
    }, [base64PDF]);
    
    useEffect(() => {
        const isComparisonPresent = docuMateUserQuery?.some((item: any) => item.que === "Comparison");
        const isSynthesizePresent = docuMateUserQuery?.some((item: any) => item.que === "Synthesization");
        if(isComparisonPresent || isSynthesizePresent) {
            setIsHeaderVisisble(true)
        }
    }, [docuMateUserQuery])

    return (
        <div className='pdf-viewer-wrapper'>
            {((docuMateRadio !== 'Compare' && docuMateRadio !== 'Synthesization') && !isHeaderVisisble) &&
            <div className='pdf-viewer-header'>
                {inputfilename ?
                    (<strong className='text-sm fw-semibold flex align-items-center' >
                        <strong className='pdf-header' title={inputfilename}>
                        {inputfilename?.length > 17
                            ? `${inputfilename?.slice(0, 17 / 2)}...${inputfilename?.slice(-17 / 2)}`
                            : inputfilename}
                        </strong>
                        {(inputfilename && showShare) && <a data-bs-toggle={showModal === false && "modal"} data-bs-target="#upload-doc" onClick={() => {
                            showModal === true && toast.warn("file already uploaded", {
                                style: {
                                    backgroundColor: '#F1F1F1', // Grey background
                                }
                            })
                        }}><i className={modalOption !== "yes" ? "pi pi-share-alt " : "pi pi-share-alt text-success"} ></i></a>} </strong>) :
                    (<strong className='text-sm flex align-items-center fw-semibold'>
                        <strong className='pdf-header' title={docuMatePDF.name}>
                        {docuMatePDF.name?.length > 17
                            ? `${docuMatePDF.name.slice(0, 17 / 2)}...${docuMatePDF.name.slice(-17 / 2)}`
                            : docuMatePDF.name}
                        </strong>
                        {(docuMatePDF.name && showShare) && <a data-bs-toggle={showModal === false && "modal"} data-bs-target="#upload-doc" onClick={() => {
                            showModal === true && toast.warn("File already shared", {
                                style: {
                                    backgroundColor: '#F1F1F1', // Grey background
                                }
                            })
                        }}><i className={modalOption !== "yes" ? "pi pi-share-alt" : "pi pi-share-alt text-success"} ></i></a>}</strong>)
                }
                {/* <strong><span>Lorem_ipsum</span>.pdf<i><img data-tooltip-content="Share" src={shareIcon} alt="share" /></i></strong> */}
                <div className='pdf-lang fw-semibold'><i><img src={languageIcon} alt='qmate-icon' /></i>{fileLanguage === "af" ? "African-Language" : fileLanguage === "en" ? "English" : fileLanguage}</div>
            </div>
            }
             {pdfSrc && (
                <iframe
                    title="PDF Viewer"
                    src={pdfSrc}
                    ref={ref}
                    width="100%"
                    height="500px"
                    frameBorder="0"
                    allowTransparency={true}
                />
            )}
        </div>
    )
}

export default Iframe